class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.content.addEventListener('mouseenter', this.onContentMouseEnter.bind(this));
    this.content.addEventListener('mouseleave', this.onContentMouseLeave.bind(this));
    //this.mainDetailsToggle.addEventListener('click', this.onClick.bind(this));
    //this.content.addEventListener('click', this.onClick.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onMouseEnter() {
    if (!this.animations) this.animations = this.content.getAnimations();
    this.animations.forEach((animation) => animation.play());
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    setTimeout(() => {
      if (!this.contains(document.activeElement) && !this.content.matches(':hover')) {
        this.close();
      }
    }, 100);
  }

  onContentMouseEnter() {
    // Keep the menu open when hovering over the content
    clearTimeout(this.leaveTimeout);
  }

  onContentMouseLeave() {
    this.leaveTimeout = setTimeout(() => {
      if (!this.contains(document.activeElement) && !this.mainDetailsToggle.matches(':hover')) {
        this.close();
      }
    }, 100);
  }

  onClick(event) {
    event.preventDefault();
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true)
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {    
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
